// Cuenta atrás de la oferta: reinicia al llegar a cero y recuerda el tiempo durante la visita
if (!customElements.get('pdp-countdown')) {
  customElements.define(
    'pdp-countdown',
    class PdpCountdown extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[data-time]');
        this.duration = (Number(this.dataset.minutes) || 15) * 60;
        this.key = 'pdp-countdown-end';
        this.end = this.readEnd();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      readEnd() {
        try {
          const saved = Number(sessionStorage.getItem(this.key));
          if (saved > Date.now()) return saved;
        } catch (error) {}
        return this.resetEnd();
      }

      resetEnd() {
        const end = Date.now() + this.duration * 1000;
        try {
          sessionStorage.setItem(this.key, String(end));
        } catch (error) {}
        return end;
      }

      tick() {
        let left = Math.round((this.end - Date.now()) / 1000);
        if (left <= 0) {
          this.end = this.resetEnd();
          left = this.duration;
        }
        const minutes = Math.floor(left / 60);
        const seconds = String(left % 60).padStart(2, '0');
        this.output.textContent = `${minutes}:${seconds}`;
      }
    }
  );
}

// Selector de talla y packs: fija la talla y la cantidad que se añaden al carrito.
// Con "Misma talla" desmarcado aparece una fila por par; si hay tallas distintas, se añaden todas juntas.
if (!customElements.get('pdp-bundles')) {
  customElements.define(
    'pdp-bundles',
    class PdpBundles extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.quantityInput = this.querySelector('[data-bundle-quantity]');
        this.sizeProperty = this.querySelector('[data-size-property]');
        this.packs = Array.from(this.querySelectorAll('[data-pack]'));
        this.sizes = Array.from(this.querySelectorAll('[data-size]'));
        this.sameSize = this.querySelector('[data-same-size]');
        this.pairsBox = this.querySelector('[data-pairs-box]');
        this.pairs = this.querySelector('[data-pairs]');
        this.pairTemplate = this.querySelector('[data-pair-template]');

        if (!this.packs.some((radio) => radio.checked) && this.packs[0]) this.packs[0].checked = true;
        if (this.sizes.length && !this.sizes.some((radio) => radio.checked)) {
          const firstAvailable = this.sizes.find((radio) => !radio.disabled);
          if (firstAvailable) firstAvailable.checked = true;
        }

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-size]')) this.syncPairsToSize();
          this.update();
        });
        this.onSubmit = this.onSubmit.bind(this);
        document.addEventListener('submit', this.onSubmit, true);
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onSubmit, true);
      }

      get quantity() {
        const checked = this.packs.find((radio) => radio.checked);
        return checked ? Number(checked.value) : 1;
      }

      get selectedSize() {
        return this.sizes.find((radio) => radio.checked);
      }

      get perPair() {
        return Boolean(this.sameSize && !this.sameSize.checked && this.quantity > 1);
      }

      get pairSelects() {
        return this.pairs ? Array.from(this.pairs.querySelectorAll('[data-pair-size]')) : [];
      }

      update() {
        this.quantityInput.value = this.quantity;
        if (this.pairsBox) this.pairsBox.hidden = this.quantity < 2;
        this.renderPairs(this.perPair ? this.quantity : 0);
        this.syncForm();
      }

      renderPairs(count) {
        if (!this.pairs) return;
        this.pairs.hidden = count === 0;
        while (this.pairs.children.length > count) this.pairs.lastElementChild.remove();
        while (this.pairs.children.length < count) {
          const row = this.pairTemplate.content.firstElementChild.cloneNode(true);
          row.querySelector('[data-pair-label]').textContent = `Par ${this.pairs.children.length + 1}`;
          if (this.selectedSize) row.querySelector('[data-pair-size]').value = this.selectedSize.value;
          this.pairs.append(row);
        }
      }

      syncPairsToSize() {
        if (!this.selectedSize) return;
        this.pairSelects.forEach((select) => (select.value = this.selectedSize.value));
      }

      syncForm() {
        const choice = this.perPair ? this.pairSelects[0]?.selectedOptions[0] : this.selectedSize;
        const variantId = choice?.dataset.variantId;
        const idInput = this.form?.querySelector('[name="id"]');
        if (variantId && idInput) idInput.value = variantId;
        if (this.sizeProperty) this.sizeProperty.value = this.sizeSummary();
      }

      // "M" o, con tallas distintas, "M ×4 · L ×3"
      sizeSummary() {
        if (!this.perPair) return this.selectedSize ? this.selectedSize.value : '';
        const counts = new Map();
        this.pairSelects.forEach((select) => counts.set(select.value, (counts.get(select.value) || 0) + 1));
        if (counts.size === 1) return this.pairSelects[0].value;
        return Array.from(counts, ([size, count]) => `${size} ×${count}`).join(' · ');
      }

      onSubmit(event) {
        if (event.target !== this.form || !this.perPair) return;
        const counts = new Map();
        this.pairSelects.forEach((select) => {
          const id = select.selectedOptions[0]?.dataset.variantId;
          if (id) counts.set(id, (counts.get(id) || 0) + 1);
        });
        if (counts.size < 2) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const button = this.form.querySelector('[type="submit"]');
        if (button) button.setAttribute('aria-disabled', 'true');
        const routes = window.routes || {};
        const cartDrawer = document.querySelector('cart-drawer');
        const items = Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
        const body = { items };
        if (cartDrawer) {
          body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }
        fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
          })
          .then((state) => {
            if (!cartDrawer || !state.sections) {
              window.location.href = routes.cart_url || '/cart';
              return;
            }
            if (button) button.removeAttribute('aria-disabled');
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents({ id: items[0].id, sections: state.sections });
          })
          .catch(() => {
            if (button) button.removeAttribute('aria-disabled');
            alert('No se ha podido añadir al carrito. Prueba con otra talla o inténtalo de nuevo.');
          });
      }
    }
  );
}

// Guía de tallas: abre la imagen en una ventana; se cierra con la X, con Esc o pulsando fuera
if (!customElements.get('pdp-size-guide')) {
  customElements.define(
    'pdp-size-guide',
    class PdpSizeGuide extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
      }

      open() {
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
          document.body.classList.add('overflow-hidden');
        } else {
          this.dialog.setAttribute('open', '');
        }
      }
    }
  );
}
